<template>
  <li class="left">
    <div class="user-avatar">
      <div class="avatar avatar-sm">
        <img :src="avatarSrc" :alt="note.user.name" />
      </div>
    </div>
    <div class="content">
      <div class="message">
        <div class="row">
          <div class="col">
            <span class="from">{{note.user.name}}</span>
          </div>
        </div>
        <p>
          {{note.note}}
        </p>
      </div>
      <div class="meta">
        <span class="age">{{note.created_at | moment("DD/MM/YYYY h:mma")}}</span>
      </div>
    </div>
  </li>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: [
    'note'
  ],
  computed: {
    avatarSrc () {
      return `${process.env.VUE_APP_API_URL}/user/${this.note.user.id}/avatar`
    }
  },
  methods: {
    ...mapActions('notes', {
			getNotes: 'getList'
		})
  },
};
</script>

<style></style>
